
import { Facet } from '../models/Facet';
import { implementOperation, IOperationActionCreator } from '../store/actions/implementOperation';

// Facet to check whether to follow / to unfollow.
export const followItemOperation = new Facet<{ isFollowed: boolean; }>('followed');

export const followItem: IOperationActionCreator<typeof followItemOperation.type> = implementOperation({
  operationTypeFacet: followItemOperation
});